import { render, staticRenderFns } from "./NewRequestPopupContent.vue?vue&type=template&id=67f8e8b1&scoped=true"
import script from "./NewRequestPopupContent.vue?vue&type=script&lang=js"
export * from "./NewRequestPopupContent.vue?vue&type=script&lang=js"
import style0 from "./NewRequestPopupContent.vue?vue&type=style&index=0&id=67f8e8b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f8e8b1",
  null
  
)

export default component.exports